// Windows forbids these in filenames; other platforms tolerate most of them but a scenario
// name typed on one machine must still save cleanly on another, so replace them everywhere.
function sanitizeFilename(name: string): string {
  return name.replace(/[\\/:*?"<>|]/g, '_');
}

export function downloadText(filename: string, text: string): void {
  const blob = new Blob([text], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = sanitizeFilename(filename);
  // Firefox requires the anchor to be in the document for the click to trigger a download.
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking synchronously can cancel the download in some browsers; a later tick lets it start.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

// oncancel is unsupported on some browsers; there the promise stays pending until a file
// is chosen. Acceptable here since the caller has no way to detect a cancelled native dialog.
export async function pickTextFile(accept = '.json'): Promise<string | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = async () => {
      const file = input.files?.[0];
      resolve(file ? await file.text() : null);
    };
    input.oncancel = () => resolve(null);
    input.click();
  });
}
